import { isNil, map } from 'lodash'

import { areSameValue } from '../../core/utils'

import { findNodeByFilter } from '../../common/utils'

const getMenuTitlesWithParents = (selectedMenuTitle, menuTitles) => {
  if (isNil(selectedMenuTitle)) {
    return []
  }

  return map(selectedMenuTitle.idPath, menuTitleId =>
    findNodeByFilter(menuTitles, node => areSameValue(node.id, menuTitleId)),
  )
}

export default getMenuTitlesWithParents
